import bem from "easy-bem";
import React, { useCallback } from "react";
import "./ToggleButton.css";

const cn = bem("social-toggle");

type ToggleButtonProps = {
  symbol: string;
  count?: number;
  toggled: boolean;
  loading: boolean;
  onClick: () => void;
  disabled?: boolean;
};

const ToggleButton: React.FC<ToggleButtonProps> = ({
  symbol,
  count,
  toggled,
  loading,
  onClick,
  disabled = false,
}) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onClick();
    },
    [onClick],
  );

  return (
    <div
      className={cn({ toggled, loading, disabled })}
      onClick={disabled ? undefined : handleClick}
      style={{ cursor: disabled ? "default" : "pointer" }}
    >
      {symbol}
      {count !== undefined ? ` ${count}` : ""}
    </div>
  );
};

export default ToggleButton;
